import React from "react";
import { Container, Row, Col, Card, Image } from "react-bootstrap";
import { Link } from "react-router-dom"; // Import useLocation
import { Mail } from "react-feather";

import logo from "../../logo.png";

const ResetPasswordConfirmation = () => {
  return (
    <Container className="min-vh-100 d-flex align-items-center justify-content-center flex-column">
      <Row>
        <Col xs={12} className="text-center mb-4">
          <Image
            src={logo}
            alt={`${process.env.REACT_APP_PORTAL}`}
            fluid
            width="225px"
          />
        </Col>
        <Col xs={11} md={9} lg={7} xl={6} xxl={6} className="m-auto">
          <Card className="p-4 shadow border-0">
            <Card.Body className="text-center">
              <Mail size={40} className="text-secondary mb-3" />
              <h1 className="text-center mb-3 fs-5">Congratulations!</h1>
              <p className="text-center mb-4 text-light-emphasis fw-light">
                Your password has been successfully reset. You can now login
                with your new password
              </p>
              <hr className="mt-5 mb-4" />
              <div className="text-center text-light-emphasis fw-light fs-medium">
                <Link
                  title="Login"
                  to="/login"
                  className="text-decoration-none link-primary fw-semibold "
                >
                  Click here {" "}
                </Link>
                to login
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ResetPasswordConfirmation;
